/**
 * Useful for parsing query strings, returns the item, first item, or undefined
 * @param val the query param value
 */
export const firstOrItem = (val: undefined | null | string | string[]) => {
    if (val === undefined || val === null) {
        return undefined;
    }
    if (typeof val === 'object') {
        return val[0];
    }
    return val;
};
